module.exports = __webpack_public_path__ + "static/media/stellaColor1.77d0b578.jpg";